import { useContext } from 'react';

import { CallConfigContext } from '/contexts/CallConfigProvider';

export const useCallConfig = () => {
  return useContext(CallConfigContext);
};
